export const Title = "MOTHER THERESSA CHARITABLE TRUST";

export const LogoName = "Mother Theressa";

export const Tagline1 = "Not all of us can do great things, ";

export const Tagline2 = "But we can do small things with great love";

export const AlbumTitle = "Moments of Impact";

export const ContactUs = "Contact Us";

export const ContactDescription = `Have questions, ideas, or want to get involved? We'd love to hear from you! Contact us today to join our mission of compassion and service.`;

export const AddressHeading = "Address";

export const Address1 = "Mother Theressa Charitable Trust,";

export const Address2 = "Y Junction,Kathikudam Road,";

export const Address3 = "Koratty P O - 680308,";

export const Phone1 = "9846788575";

export const Phone2 = "7034138575";

export const Phone3 = "04802998575";

export const Email = "mtctchalakudy@gmail.com";

export const FooterHead = "MOTHER THERESSA Charitable Trust";

export const FbLink = "https://www.facebook.com/Mothertheressa?mibextid=ZbWKwL";

export const Donate = "SCAN TO DONATE";

export const AccountName = "A/c No :";

export const IFSC = "IFSC Code:";

export const AccountNumber = "0012073000001685";

export const IfscCode = "SIBL0000646";

export const BankName = "South Indian Bank";

export const BranchName = "Koratty Branch";

export const FooterQuote =
  " It’s not how much we give, but how much love we put into giving!";

export const AboutUsDescription =
  " Welcome to the Mother Theressa Charitable Trust, a compassionate organization committed to serving humanity through social and volunteer services. Established under the Indian Charitable Trust Act, 1982, we have been a beacon of hope and support for the underprivileged irrespective of caste or religion for nearly 5 years.";

export const Mission =
  " At Mother Theressa Charitable Trust, our mission is to extend a helping hand to those in need through street Food distribution,study assistance, medical assistance,food kit distribution and blood donation.";

export const Plan =
  " To bring our vision to life and achieve our mission, we are committed to expanding our reach by strengthening our presence and extending our services to reach more individuals in need across our society.";

export const Vision =
  "We envision a world where every individual, especially those in challenging circumstances, is enveloped in the warm embrace of hope, guiding them towards a future filled with boundless opportunities for empowerment.";

export const ServicesDescription = `Explore our impactful services designed to uplift and empower individuals in need. From providing essential nourishment to distributing life-saving resources and educational support, our mission is to make a meaningful difference in the lives of those facing adversity. Discover how we're building a brighter future one act of kindness at a time.`;

export const Service1 = "Street Food Distribution";

export const Service1Description =
  " We provide nutritious meals to individuals living on the streets, ensuring they have access to food and basic sustenance.";

export const Service2 = "Cancer Patient Support";

export const Service2Description =
  " We offer compassionate care and treatment for impoverished cancer patients, alleviating their physical and emotional burdens.";

export const Service3 = "Medical Assistance for Kidney Patients";

export const Service3Description =
  "Indigent kidney patients receive vital medical support and resources to manage their condition and improve their quality of life.";

export const Service4 = "Blood Donation Support";

export const Service4Description =
  "Through our network, we facilitate blood donation drives and ensure timely access to life-saving blood transfusions for patients in need.";

export const Service5 = "Study Assistance Program";

export const Service5Description =
  " We support underprivileged students with educational resources and scholarships, empowering them to pursue their academic aspirations.";

export const Service6 = "Therapeutic Services for Autistic Children";

export const Service6Description =
  "We provide specialized treatment and care for autistic children,fostering their development and well-being.";
